export default {
  LSN_1: {
    title: 'Publicaciones',
    description: 'Suma de publicaciones recopiladas en la investigación.',
  },
  LSN_2: {
    title: 'Usuarios',
    description: 'Recuento de usuarios únicos que generaron el total de publicaciones en la investigación.',
  },
  LSN_3: {
    title: 'Net Promoter Score',
    description: 'Representa el resultado de la ecuación: (publicaciones positivas / publicaciones recopiladas * 100) - (publicaciones negativas / publicaciones recopiladas * 100).',
  },
  LSN_4: {
    title: 'Alcance Potencial',
    description: 'Representa el 20% de la suma de seguidores/suscriptores de los perfiles recopilados en la investigación.',
  },
  LSN_5: {
    title: 'Índice de Sentimiento',
    description: 'Representa el resultado de la ecuación: (publicaciones positivas + publicaciones neutras - publicaciones negativas) / total de publicaciones.',
  },
  LSN_6: {
    title: 'Distribución por Sentimiento',
    description: 'División de las publicaciones por polaridad positiva, negativa o neutra.',
  },
  LSN_7: {
    title: 'Distribución por Género',
    description: 'División de las publicaciones por Hombre, Mujer y Organización.',
  },
  LSN_8: {
    title: 'Distribución por Dispositivo',
    description: 'División de las publicaciones por Móvil/Tablet y Computador.',
  },
  LSN_9: {
    title: 'Distribución por Canal',
    description: 'División de las publicaciones por canal de recopilación (listening).',
  },
  LSN_10: {
    title: 'Principales Influenciadores',
    description: 'Ranking de influenciadores ordenados por la metodología AAA (puntuación de influencia compuesta por Atractivo del Contenido, Afinidad con la Investigación y Alcance del Influenciador).',
  },
  LSN_11: {
    title: 'Publicaciones más Populares',
    description: 'Top publicaciones mostradas en carrusel, ordenadas por la ponderación entre el tiempo de publicación y el engagement recibido recientemente.',
  },
  LSN_12: {
    title: 'Términos Correlacionados',
    description: 'Muestra los principales términos relacionados con la investigación dentro de un intervalo de tiempo. La proximidad indica el grado de relación. El tamaño de las esferas indica el volumen de publicaciones.',
  },
  LSN_13: {
    title: 'Publicaciones en el Tiempo',
    description: 'Distribución lineal de las publicaciones recopiladas a lo largo de un período de tiempo.',
  },
  LSN_14: {
    title: 'Sentimiento en el Tiempo',
    description: 'Distribución de las publicaciones por su polaridad a lo largo de un período de tiempo.',
  },
  LSN_15: {
    title: 'Sentimiento por Término',
    description: 'Distribución de publicaciones por los términos más mencionados y su desglose por polaridad.',
  },
  LSN_16: {
    title: 'Sentimiento por Grupo',
    description: 'Distribución de publicaciones por los Grupos registrados en la investigación más mencionados y su desglose por polaridad.',
  },
  LSN_17: {
    title: 'Sentimiento por Tema',
    description: 'Distribución de publicaciones por los Temas registrados en la investigación más mencionados y su desglose por polaridad.',
  },
  LSN_18: {
    title: 'Anotaciones de Texto',
    description: 'Área de texto editable libre para escribir análisis, leyendas y/u observaciones.',
  },
  LSN_19: {
    title: 'Insertar Imagen',
    description: 'Componente para insertar imágenes por archivo o URL.',
  },
  LSN_20: {
    title: 'Canales en el Tiempo',
    description: 'Distribución de las publicaciones recopiladas divididas por canal de recopilación a lo largo de un período de tiempo.',
  },
  LSN_21: {
    title: 'Termómetro de Sentimiento',
    description: 'Representa, como gauge, el resultado de la ecuación: (publicaciones positivas / publicaciones recopiladas * 100) - (publicaciones negativas / publicaciones recopiladas * 100).',
  },
  LSN_22: {
    title: 'Publicaciones con más Me Gusta',
    description: 'Tarjetas en lista ordenada por volumen de me gusta en publicaciones recopiladas (incluye posts, publicaciones e interacciones).',
  },
  LSN_23: {
    title: 'Publicaciones más Recientes',
    description: 'Tarjetas en lista ordenada por tiempo de las publicaciones recopiladas (incluye posts, publicaciones e interacciones).',
  },
  LSN_24: {
    title: 'Nube de Términos',
    description: 'Muestra los términos más citados relacionados con la investigación como una nube de palabras.',
  },
  LSN_25: {
    title: 'Divisor de Sección',
    description: 'Campo de texto para títulos de segmentos y secciones del dashboard.',
  },
  LSN_26: {
    title: 'Publicaciones con Más Seguidores',
    description: 'Tarjetas en lista ordenada por cantidad de seguidores del perfil de la publicación.',
  },
  LSN_27: {
    title: 'Publicaciones con Mayor Engagement',
    description: 'Tarjetas en lista ordenada por el total de engagement generado en la publicación.',
  },
  LSN_28: {
    title: 'Me Gusta',
    description: 'Suma de me gusta en las publicaciones recopiladas.',
  },
  LSN_29: {
    title: 'Comentarios',
    description: 'Suma de comentarios en las publicaciones recopiladas.',
  },
  LSN_30: {
    title: 'Compartidos',
    description: 'Suma de compartidos en las publicaciones recopiladas.',
  },
  LSN_31: {
    title: 'Engagement',
    description: 'Suma de todas las acciones de engagement en las publicaciones recopiladas.',
  },
  LSN_32: {
    title: 'Engagement en el Tiempo',
    description: 'Suma de todas las acciones de engagement recopiladas en publicaciones, distribuida en el período de tiempo seleccionado.',
  },
  LSN_33: {
    title: 'Sentimiento por Canal',
    description: 'Distribución de publicaciones por canales recopilados y su desglose por polaridad.',
  },
  LSN_34: {
    title: 'Sentimiento por Etiqueta',
    description: 'Distribución de publicaciones por Etiquetas registradas en la investigación y su desglose por polaridad.',
  },
  LSN_35: {
    title: 'Sentimiento por Género',
    description: 'Distribución de publicaciones por género y su desglose por polaridad.',
  },
  LSN_36: {
    title: 'Menciones por Grupo en el Tiempo',
    description: 'Distribución de publicaciones por Grupos registrados en la investigación a lo largo del tiempo.',
  },
  LSN_37: {
    title: 'Engagement por Grupo en el Tiempo',
    description: 'Distribución de la suma de acciones de engagement recopiladas en publicaciones y clasificadas en Grupos de la investigación a lo largo del tiempo.',
  },
  LSN_38: {
    title: 'Publicaciones por Tema en el Tiempo',
    description: 'Distribución de publicaciones por Temas registrados en la investigación a lo largo del tiempo.',
  },
  LSN_39: {
    title: 'Engagement por Tema en el Tiempo',
    description: 'Distribución de la suma de acciones de engagement recopiladas en publicaciones y clasificadas en Temas de la investigación a lo largo del tiempo.',
  },
  LSN_40: {
    title: 'Publicaciones por Etiqueta en el Tiempo',
    description: 'Distribución de publicaciones por Etiquetas asignadas en la investigación a lo largo del tiempo.',
  },
  LSN_41: {
    title: 'Engagement por Etiqueta en el Tiempo',
    description: 'Distribución de la suma de acciones de engagement recopiladas en publicaciones y clasificadas por Etiquetas a lo largo del tiempo.',
  },
  LSN_42: {
    title: 'Engagement por Grupo',
    description: 'Distribución del total de interacciones en publicaciones por grupos de la investigación.',
  },
  LSN_43: {
    title: 'Engagement por Temas',
    description: 'Distribución del total de interacciones en publicaciones por temas de la investigación.',
  },
  LSN_44: {
    title: 'Engagement por Etiquetas',
    description: 'Distribución del total de interacciones en publicaciones por etiquetas de la investigación.',
  },
  LSN_45: {
    title: 'Sentimiento en el Tiempo (Porcentaje)',
    description: 'Distribución de publicaciones por proporción porcentual de positivas, negativas y neutras a lo largo de un período de tiempo.',
  },
  LSN_46: {
    title: 'Publicaciones por Grupo en el Tiempo',
    description: 'Distribución de publicaciones por Grupos registrados en la investigación.',
  },
  LSN_47: {
    title: 'Publicaciones por Tema',
    description: 'Distribución de publicaciones por Temas registrados en la investigación.',
  },
  LSN_48: {
    title: 'Publicaciones por Etiqueta',
    description: 'Distribución de publicaciones por etiquetas asignadas.',
  },
  LSN_49: {
    title: 'Variación de la Base de Fans (Comparativo)',
    description: 'Comparación entre el total de fans antes de la fecha de inicio y en la fecha final del período investigado (marcas o competidores).',
  },
  LSN_50: {
    title: 'Total de Fans (Comparativo)',
    description: 'Total de fans de las páginas seleccionadas en la fecha final del período investigado (marcas o competidores).',
  },
  LSN_51: {
    title: 'Nuevos Fans (Comparativo)',
    description: 'Total de fans ganados por las páginas seleccionadas en el período investigado (marcas o competidores).',
  },
  LSN_52: {
    title: 'Evolución de la Base de Fans (Comparativo)',
    description: 'Variación diaria de fans de las páginas investigadas en el período, relativa al día anterior (marcas o competidores).',
  },
  LSN_53: {
    title: 'Distribución por Medio',
    description: 'Distribución de publicaciones por los medios más mencionados y su desglose por polaridad.',
  },
  LSN_54: {
    title: 'Equivalencia Publicitaria',
  },
  LSN_55: {
    title: 'Destacados de Portales',
  },
  LSN_56: {
    title: 'Destacados de TV',
  },
  LSN_57: {
    title: 'Destacados de Impresos',
  },
  LSN_58: {
    title: 'Destacados de Radio',
  },
  LSN_59: {
    title: 'PR Score',
    description: 'Puntuación basada en una nota dada a los artículos de prensa.',
  },
  LSN_60: {
    title: 'Salud de la Marca',
    description: 'Suma el porcentaje de menciones positivas y neutras.',
  },
  LSN_61: {
    title: 'Salud de la Marca por Grupo',
    description: 'Suma el porcentaje de menciones positivas y neutras por grupo en comparación con el total de menciones.',
  },
  LSN_62: {
    title: 'Salud de la Marca por Tema',
    description: 'Suma el porcentaje de menciones positivas y neutras por grupo en comparación con el total de menciones.',
  },
  LSN_63: {
    title: 'Comparativo Precio vs. Menciones',
  },
  LSN_64: {
    title: 'Comparativo Volumen vs. Menciones',
  },
  LSN_65: {
    title: 'Comparativo Precio vs. Sentimiento',
  },
  LSN_66: {
    title: 'Importar Archivo',
    description: 'Componente para insertar archivos por archivo o URL.',
  },
  LSN_67: {
    title: 'Historial de Importación',
    description: 'Componente para visualizar los registros del historial de importación.',
  },
  LSN_68: {
    title: 'Búsqueda',
    description: 'Componente para búsqueda textual libre.',
  },
  LSN_69: {
    title: 'Informe de Anotaciones',
    description: 'Componente para auditoría de anotaciones y cambio de estado.',
  },
  LSN_70: {
    title: 'Sugerencias de Respuestas vía ChatGPT',
    description: 'Componente para generar respuestas automáticas.',
  },
  LSN_71: {
    title: 'Sentimiento por Etiqueta con Filtro en Árbol',
    description: 'Distribución de publicaciones por Etiquetas registradas en la investigación y su desglose por polaridad.',
  },
  LSN_72: {
    title: 'Importar Comentarios',
    description: 'Componente para insertar comentarios de publicaciones vía planilla.',
  },
  LSN_73: {
    title: 'Canales por Grupo',
    description: 'Distribución de canales por Grupos registrados en la investigación.',
  },
  LSN_74: {
    title: 'Publicaciones por Grupo',
    description: 'Distribución de publicaciones por grupos registrados en la investigación.',
  },
  LSN_75: {
    title: 'Publicaciones por Etiqueta',
    description: 'Distribución de publicaciones por etiquetas asignadas.',
  },
  LSN_76: {
    title: 'Publicaciones por Tema',
    description: 'Distribución de publicaciones por Temas registrados en la investigación.',
  },
  LSN_78: {
    title: 'Publicaciones por Tema con Filtro Personalizado',
    description: 'Distribución de publicaciones por Temas registrados en la investigación.',
  },
  LSN_79: {
    title: 'Agregar Etiquetas a Publicaciones',
    description: 'Componente para agregar etiquetas a publicaciones mediante importación de planilla.',
  },
  LSN_80: {
    title: 'Proyección de Muestreo de Publicaciones',
    description: 'Proyección del volumen de publicaciones recopiladas en el período investigado, considerando el muestreo de publicaciones.',
  },
};
